module.exports = __webpack_public_path__ + "static/media/nothing-found.8fc79dd1.svg";